import { defineMessages } from 'react-intl';

export default defineMessages({
  skinTone: {
    id: 'cboard.components.SkinTone.skinTone',
    defaultMessage: 'Skin Tone'
  },
  clearSelection: {
    id: 'cboard.components.SkinTone.clearSelection',
    defaultMessage: 'Clear selection'
  }
});
